export class Message {
  public alias: string = "com.bcdfx.broker.MessageImpl";
  constructor(public jsonMessage: string) {}

  public toString(): string {
    return "Message[" + "jsonMessage=" + this.jsonMessage + "]";
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
